import { Plus } from 'lucide-react';
import Button from './Button';

export interface AddButtonProps {
  onClick: () => void;
  disabled?: boolean;
  label: string;
  className?: string;
}

export default function AddButton({ onClick, disabled = false, label, className = '' }: AddButtonProps) {
  return (
    <Button disabled={disabled} onClick={onClick} className={className}>
      <Plus className="mr-2 h-4 w-4" />
      {label}
    </Button>
  );
}
